import Page from 'components/Page'
import { StickyPanelFrame } from 'components/Page/StickyPanelFrame'
import { SeatBalancesMagicTable } from 'modules/Seats/SeatBalances/SeatBalancesMagicTable'
import { FC, memo } from 'react'

const SeatBalances: FC = memo(() => {
  return (
    <StickyPanelFrame>
      <Page title="Balances" paddingBottom={0}>
        <SeatBalancesMagicTable />
      </Page>
    </StickyPanelFrame>
  )
})

export default SeatBalances
